import * as React from "react";
import { CpFormContext } from "./CpFormContext";

export function useCpFormContext() {
  const context = React.useContext(CpFormContext);
  return context;
}
